import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
let LoginLinkMixin = class LoginLinkMixin extends Vue {
    buildLoginLink(plan, code, isAppLink) {
        let path = '/diy/choose-service-bundle';
        if (isAppLink) {
            path = '/apps';
        }
        switch (plan) {
            case TierType.ProStarter:
                return `${path}?plan_type=${TierType.ProStarter}${this.addCodeParameter(code)}`;
            case TierType.ProBronze:
                return `${path}?plan_type=${TierType.ProBronze}${this.addCodeParameter(code)}`;
            case TierType.ProSilver:
                return `${path}?plan_type=${TierType.ProSilver}${this.addCodeParameter(code)}`;
            default:
                if (!plan && code) {
                    return `${path}?affiliate_code=${code}`;
                }
                return path;
        }
    }
    addCodeParameter(code) {
        if (code) {
            return `&affiliate_code=${code}`;
        }
        return '';
    }
};
LoginLinkMixin = __decorate([
    Component
], LoginLinkMixin);
export default LoginLinkMixin;
